/* Outdoor Paws — scrolling message marquee (JS-driven for reliable motion)
 * Clones the message set enough times to fill the bar, then scrolls at a
 * steady pixels-per-second speed. Pauses on hover; re-inits on resize/editor. */
(function () {
  'use strict';

  class OpMarquee extends HTMLElement {
    connectedCallback() { this.init(); window.addEventListener('resize', this._onResize = this._debounced()); }
    disconnectedCallback() { if (this._anim) this._anim.cancel(); window.removeEventListener('resize', this._onResize); }

    _debounced() {
      var self = this, t;
      return function () { clearTimeout(t); t = setTimeout(function () { self.init(); }, 200); };
    }

    init() {
      this.track = this.querySelector('.opm__track');
      this.set = this.querySelector('.opm__set');
      if (!this.track || !this.set) return;

      if (this._anim) { this._anim.cancel(); this._anim = null; }
      this.track.querySelectorAll('[data-clone]').forEach(function (n) { n.remove(); });

      var setW = this.set.getBoundingClientRect().width;
      if (setW < 2) return;

      // Clone the set until the track comfortably exceeds twice the viewport.
      var need = this.offsetWidth * 2 + setW, total = setW;
      while (total < need) {
        var c = this.set.cloneNode(true);
        c.setAttribute('data-clone', ''); c.setAttribute('aria-hidden', 'true');
        this.track.appendChild(c); total += setW;
      }

      var pxPerSec = 24 + (parseInt(this.getAttribute('data-speed'), 10) || 25);
      var duration = (setW / pxPerSec) * 1000;

      if (!this.track.animate) return; // very old browser: leave static
      this._anim = this.track.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + setW + 'px)' }],
        { duration: duration, iterations: Infinity, easing: 'linear' }
      );

      this.onmouseenter = function () { if (this._anim) this._anim.pause(); }.bind(this);
      this.onmouseleave = function () { if (this._anim) this._anim.play(); }.bind(this);
    }
  }

  if (!window.customElements.get('op-marquee')) {
    window.customElements.define('op-marquee', OpMarquee);
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('op-marquee'); if (el && el.init) el.init();
  });
})();
